import * as components from './components'

export default [
  {
    path: '/user/track/:role',
    component: components.UserTrack,
    name: 'userTrack',
    props: true
  },
  {
    path: '/user/profile',
    component: components.UserProfile,
    name: 'userProfile',
    props: true
  },
  {
    path: '/user/tour',
    component: components.UserTour,
    name: 'userTour',
    props: true
  },
  {
    path: '/user/zendesk',
    component: components.UserZendesk,
    name: 'userZendesk',
    props: true
  },
  {
    path: '/user/setup',
    component: components.UserSetup,
    name: 'userSetup',
    props: true
  },
  {
    path: '/user/logout',
    component: components.UserLogout,
    name: 'userLogout',
    props: true
  },
  {
    path: '/user/list',
    component: components.ListUsers,
    name: 'listUsers',
    props: true
  },
  {
    path: '/user/create',
    component: components.CreateUser,
    name: 'createUser',
    props: true
  },
  {
    path: '/user/create/email',
    component: components.CreateUserByEmail,
    name: 'createUserByEmail',
    props: true
  },
  {
    path: '/user/:uuid/edit',
    component: components.EditUser,
    name: 'editUser',
    props: true
  },
  {
    path: '/user/:uuid/settings',
    component: components.UserSettings,
    name: 'userSettings',
    props: true
  },
  {
    path: '/user/upload',
    component: components.UserUpload,
    name: 'userUpload',
    props: true
  },
  {
    path: '/privacyPolicy',
    component: components.PrivacyPolicy,
    name: 'privacyPolicy',
    props: true
  },
  {
    path: '/user/:uuid/subscription',
    component: components.ClearlyNextStudentSubscription,
    name: 'clearlyNextStudentSubscription',
    props: true
  },
  {
    path: '/user/subscription/success',
    component: components.ClearlyNextStudentSubscriptionSuccess,
    name: 'clearlyNextStudentSubscription',
    props: true
  },
  {
    path: '/user/subscription/failure',
    component: components.ClearlyNextStudentSubscriptionFailure,
    name: 'clearlyNextStudentSubscription',
    props: true
  },
  {
    path: '/unmudl/setupExplore',
    component: components.UnmudlExploreSetup,
    name: 'unmudlExploreSetup',
    props: true
  },
  {
    path: '/termsAndConditions',
    component: components.TermsAndConditions,
    name: 'termsAndConditions',
    props: true
  },
  {
    path: '/dataPrivacy',
    component: components.DataPrivacy,
    name: 'dataPrivacy',
    props: true
  },
  {
    path: '/user/setupCourseDashboard',
    component: components.WidgetCourseDashboardSetup,
    name: 'widgetCourseDashboardSetup',
    props: true
  },
  {
    path: '/purchases',
    component: components.Purchases,
    name: 'purchases',
    props: true
  },
  {
    path: '/wallet',
    component: components.Wallet,
    name: 'wallet',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/user/routes.js